export default __webpack_public_path__ + "0e4109e51a490874726c5cd53a028d2a.png";